import React, { ChangeEvent, useCallback, useEffect, useRef, useState } from "react";
import i18next from "i18next";
import { useMapContext } from "../../Contexts/MapContext";
import { WidgetToolbar } from "../Widget/WidgetToolbar";
import { WidgetInput } from "../Widget/WidgetInput";
import { Select } from "../../Elements/Select";
import { IFormat } from "../../Contexts/PrintContext";
import { PopupButton } from "../../Elements/PopupButton";
import { exportFeatures } from "./exportFunctions";
import "./Export.scss";
import { AccordionItem } from "../../Elements/Accordion";

const fileFormat = [
    {
        label: "Kml",
        value: "kml"
    },
    {
        label: "Kmz",
        value: "kmz"
    },
    {
        label: "Gpx",
        value: "gpx"
    }
];

export const Export = (): JSX.Element => {
    const { drawnFeatures } = useMapContext();
    const [title, setTitle] = useState<string>("");
    const [format, setFormat] = useState<IFormat>(fileFormat[0]);

    const onExport = useCallback(async () => {
        const blob = await exportFeatures(format, drawnFeatures, title || "eksports");

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = (title || "eksports") + "." + format.value;
        link.click();
        URL.revokeObjectURL(link.href);
    }, [title, format, drawnFeatures]);

    return (
        <AccordionItem title={i18next.t("sketch.exportGeometry")} changeHeight={Date.now()} key="geometryExport">
            <WidgetInput
                classname="export-filename"
                label={i18next.t("export.inputTitle")}
                value={title}
                onChange={(e) => setTitle(e.target.value)}
            />
            <Format format={format} setFormat={setFormat}></Format>
            <div className="export-button">
                <PopupButton title={i18next.t("print.export")} disabled={!drawnFeatures.length} onClick={onExport} />
            </div>
        </AccordionItem>
    );
};

const Format = ({ format, setFormat }: { format: IFormat; setFormat: CallableFunction }) => {
    const onClickGroup = (e: ChangeEvent<HTMLSelectElement>) => {
        const groupValue = fileFormat.find((o) => o.label === e.target.value);
        setFormat(groupValue);
    };
    return (
        <div className="file-format">
            <label>{i18next.t("export.formats")} </label>
            <Select
                title={i18next.t("export.formats")}
                config={{ field: "searchGroup" }}
                options={fileFormat}
                defaultValue={format.value}
                onChange={onClickGroup}
            />
        </div>
    );
};
